import { Nullable } from 'constants/types'
import { ATTR_NAME } from 'constants/attr-name'
import { ScriptService } from 'services/script/script.service'

export class SkimLinks {
    private accountId: Nullable<string>

    /**
     * Load the data and show the widget (if data was returned)
     */
    public constructor(private el: HTMLElement) {
        this.accountId = this.el.getAttribute(
            ATTR_NAME.widget.skimlinks.accountId
        )
        this.processBlacklist()
        this.init()
    }

    public init(): void {
        ScriptService.getInstance()
            .loadScript(
                {
                    name: 'skimlinks',
                    src: `https://s.skimresources.com/js/${this.accountId}.skimlinks.js`,
                    loaded: false
                },
                undefined,
                true
            )
            .catch((error: Error) => console.error(error))
        this.registerListener()
    }

    private registerListener(): void {
        // If the page is already ready
        if (document.readyState === 'complete') {
            this.checkSkimlinksDisclosure()
        } else {
            // If the DOM is ready but not all the resources have finished loading
            if (document.readyState === 'interactive') {
                // Do a first check now and we will re-check when the state changes again.
                this.checkSkimlinksDisclosure()
            }
            // Check each time the readystate of the page changes.
            document.addEventListener(
                'readystatechange',
                this.checkSkimlinksDisclosure
            )
        }
    }

    /** Setup to call Skimlinks disclosure API when the page is ready */

    private checkSkimlinksDisclosure(): void {
        // Make sure Skimlinks has loaded.
        if (window.skimlinksAPI && window.skimlinksAPI.getDisclosureStatus) {
            // Asynchronous call to check the disclosure status.
            window.skimlinksAPI.getDisclosureStatus(
                (skimlinksDisclosureStatus: Skimlink.DisclosureStatus) => {
                    SkimLinks.onDisclosureStatus(skimlinksDisclosureStatus)
                }
            )
        }
    }

    /**
       Callback function executed once Skimlinks has resolved the disclosure status.
       You can use here the skimlinksDisclosureStatus param to update your page with
       your disclosure message.
       Warning: This function can potentially be called multiple times.

       @param {Skimlink.DisclosureStatus} skimlinksDisclosureStatus -s contains the disclosure information
    */
    static onDisclosureStatus(
        skimlinksDisclosureStatus: Skimlink.DisclosureStatus
    ): void {
        // Update the display of your disclosure banner
        if (skimlinksDisclosureStatus.hasAffiliateLinks) {
            const disclaimer = document.getElementById('disclaimer')
            if (
                disclaimer &&
                skimlinksDisclosureStatus.affiliateDomains &&
                skimlinksDisclosureStatus.affiliateDomains.length > 0
            ) {
                disclaimer.hidden = false
            }
        }
    }

    private processBlacklist(): void {
        // setup page_settings object
        const blacklistedUrls = this.el.getAttribute(
            ATTR_NAME.widget.skimlinks.blackList
        )
        let splitBlackListedUrls: Array<string> = []
        if (blacklistedUrls) {
            splitBlackListedUrls = blacklistedUrls.split(',')
        }

        window.skimlinks_settings = window.skimlinks_settings || {}

        window.skimlinks_settings.skimlinks_exclude =
            splitBlackListedUrls ||
            window.skimlinks_settings.skimlinks_exclude ||
            []
        window.skimlinks_settings.skimlinks_target = '_blank'
    }
}
